const COLLAPSED_KEY = 'pacilo.admin.sidebar.collapsed';

export function readSidebarCollapsed() {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSidebarCollapsed(collapsed) {
  try {
    localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    // Ignore storage access failures.
  }
}
